export default (that) => [
  {
    text: that.$l('table_opt_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('table_opt_edit') || '编辑信息',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ status }) => !['A'].includes(status),
  },
  {
    text: that.$l('table_opt_delete') || '删除信息',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ status }) => !['A', 'S'].includes(status),
  },
  {
    text: that.$l('table_opt_copy') || '复制信息',
    icon: 'el-icon-copy-document',
    menuType: 'copy',
    divided: true,
    allow: 'P',
    disabled: ({ status }) => !['S'].includes(status),
  },
  {
    text: that.$l('table_opt_audit') || '审核确认',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: false,
    allow: 'C',
    disabled: ({ status }) => !['A'].includes(status),
  },
  {
    text: that.$l('table_opt_audit_edit') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'auditEdit',
    divided: true,
    allow: 'R',
    disabled: ({ status }) => !['S'].includes(status),
  },
  {
    text: that.$l('menu_text_export') || '导出工价表',
    icon: 'el-icon-right',
    menuType: 'export',
    divided: true,
    allow: 'E',
    data: { templateGroup: 'factory-orderTechPricing' },
    disabled: ({ status }) => {
      return (
        status === 'D'
      )
    },
  },
]
